import { Route } from 'react-router-dom';

import ProtectedRoute from '../Components/ProtectedRoute';
import IRoute from '../Models/IRoute';

const RouteBuilder = (routes: IRoute[][][]) => {
  const flatRotues = routes.flat(2);

  const createParameterString = (params?: string[]) =>
    !params ? '' : '/' + params.map((param) => ':' + param).join('/');

  return flatRotues.map((route) => {
    const path = route.path + createParameterString(route.parameters);
    const component = route.needAuth ? (
      <ProtectedRoute>
        <route.component />
      </ProtectedRoute>
    ) : (
      <route.component />
    );

    return <Route key={path} path={path} element={component} />;
  });
};

export default RouteBuilder;
